import { create } from 'zustand'

interface ProfileDraft {
  firstName?: string
  lastName?: string
  username?: string
  email?: string
  avatar?: string
  referralCode?: string
}

interface ProfileDraftState {
  draft: ProfileDraft
  setDraft: (draft: Partial<ProfileDraft>) => void
  clearProfileDraft: () => void
  updateDraft: (updates: Partial<ProfileDraft>) => void
}

export const useProfileDraftStore = create<ProfileDraftState>((set) => ({
  draft: {},

  setDraft: (draft: Partial<ProfileDraft>) => {
    set({ draft })
  },

  clearProfileDraft: () => {
    set({ draft: {} })
  },

  updateDraft: (updates: Partial<ProfileDraft>) => {
    set((state) => ({
      draft: { ...state.draft, ...updates },
    }))
  },
}))
